module.exports = __webpack_public_path__ + "static/media/Icn-sav.69ad95d8.svg";